import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, createVNode as _createVNode, vShow as _vShow, unref as _unref, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("重置穿透搜索")
const _hoisted_2 = {
  key: 0,
  class: "mt-10 mb-10"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("计算订单本位币")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("获取订单")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("修改确认关单时间")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改发票主体")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("修改国家")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确定")

import { ref, computed, reactive, onActivated, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix, {orgCfig} from '@/global_mixin/tableMixin'
import { useRoute, useRouter } from 'vue-router'
import { categorysFunc } from '@/views/typeMapping/OrderMap'
import store from "@/store/index";
import { formatNumber, getNumber, formatTime, exportHandle } from '@/utils/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  props: {
  readTableOnly: {
    type: Boolean,
    default: false
  },
},
  setup(__props, { expose }) {

const props = __props

const { 
  'POST/order/list': fetchList,
  // 计算本位币（订单）
  'POST/order/receivable/compute_rate': compute_rateApi,
  // 获取订单
  'POST/order/sync_order': sync_orderApi,
  // 订单导出
  'POST/order/list/export': exportOrderApi,
  // 修改确认关单时间
  'POST/order/update/financial_time': financial_timeEditApi,
  // 开票公司列表
  'GET/order/invoice_companies': invoice_companiesApi,
  // 修改开票公司
  'POST/order/update/invoice_company': invoice_companyApi,
  // 订单状态列表
  'GET/order/status_list': status_listApi,
  // 国别列表
  'GET/order/receivable/clients/countries': countriesListApi,
  // 修改国家
  'POST/order/update/country': modifyCountryApi,
  // 订单类别下拉框
  'GET/order_categorys/list': order_categorysListApi,
  // 回款公司下拉查询
  'GET/order/dropdown/flow_company': flow_companyApi,
} = Api
let {currencyOption} = PaymentModuleUtils



const searchForm = ref()
const route = useRoute()
const router = useRouter()
let orderRows= ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

let companyInvice: any = ref([])
let orderCategorysOption: any = ref([])
let orderOption: any = ref([])
let flowCompanyList: any = ref([])
const userList = computed(() => {
  return store.getters.sysUsers.map((e: any) => {
    e.label = `${e.alias}(${e.realName})`
    return e
  })
})
const searchConfig = ref([
  {
    label: "订单编号",
    value: '',
    upKey: 'no',
    props: { clearable : true }
  },
  {
    label: "客户名称",
    value: '',
    upKey: 'customerName',
    props: { clearable : true }
  },
  {
    label: "客户ID",
    value: '',
    upKey: 'customerId',
    props: { clearable : true }
  },
  {
    type: "TIME",
    label: "起始完工时间",
    value: '',
    upKey: 'deliverTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束完工时间",
    value: '',
    upKey: 'deliverTimeTo',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "起始关单时间",
    value: '',
    upKey: 'closeTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束关单时间",
    value: '',
    upKey: 'closeTimeTo',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "起始确认关单时间",
    value: '',
    upKey: 'confirmCloseTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束确认关单时间",
    value: '',
    upKey: 'confirmCloseTimeTo',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "开始回款时间",
    value: '',
    upKey: 'financialTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束回款时间",
    value: '',
    upKey: 'financialTimeTo',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "开始核销时间",
    value: '',
    upKey: 'verifyTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束核销时间",
    value: '',
    upKey: 'verifyTimeTo',
    props: {
      clearable: true,
    }
  },
  {
    type: 'SELECT',
    label: '类型',
    value: '',
    upKey: 'dateType',
    options: [
      { label: '按年份', id: 'year' },
      { label: '按月份', id: 'month' },
      { label: '按季度', id: 'quarter' },
    ],
    props: { placeholder: '请选择类型', clearable: true },
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '关单与确认关单',
    value: '',
    upKey: 'noEqualTime',
    options: [
      { label: '时间不相等', id: true },
    ],
    props: { clearable: true, placeholder: '请选择是否相等', },
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '状态',
    value: '',
    upKey: 'statusList',
    options: orderOption,
    props: {clearable: true, placeholder: '请选择订单状态', multiple: true, 'collapse-tags': true },
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    type: 'SELECT',
    label: '国内外收入',
    value: '',
    upKey: 'domestic',
    options: [
      { label: '国内', id: 'true'},
      { label: '国外', id: 'false' },
    ],
    props: {clearable: true, placeholder: '请选择国内外收入'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '国内外订单设置',
    value: '',
    upKey: 'unSetDomestic',
    options: [
      { label: '未设置', id: 'true'},
      { label: '全部订单', id: 'false' },
    ],
    props: {clearable: true, placeholder: '请选择国内外收入'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '币种',
    value: [],
    upKey: 'currency',
    options: currencyOption(),
    props: {clearable: true, placeholder: '请选择币种', multiple: true, 'collapse-tags': true},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    type: 'SELECT',
    label: 'deliverTimes是否为空',
    value: '',
    upKey: 'isNullDeliverTime',
    options: [
      { label: '为空', id: 'true'},
      { label: '不为空', id: 'false' },
    ],
    props: {clearable: true, placeholder: '请选择国内外收入'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: "TIME",
    label: "开始时间范围",
    value: '',
    upKey: 'startTimeFrom',
    props: {
      clearable: true,
    }
  },
  {
    type: "TIME",
    label: "结束时间范围",
    value: '',
    upKey: 'startTimeTo',
    props: {
      clearable: true,
    }
  },
  orgCfig({
    upKey: 'coTwoOrgId'
  }),
  {
    type: 'SELECT',
    label: '订单类别',
    value: '',
    upKey: 'categoryId',
    options: orderCategorysOption,
    props: {clearable: true, placeholder: '请选择订单类别' },
    seleProps: { label: 'label', valueName: 'categoryId' },
  },
  {
    type: 'SELECT',
    label: 'PM',
    value: '',
    upKey: 'pmList',
    options: userList,
    props: { placeholder: '请选择PM', clearable: true, multiple: true, 'collapse-tags': true },
    seleProps: { label: 'label', valueName: 'alias', }
  },
  {
    type: 'SELECT',
    label: 'CM',
    value: '',
    upKey: 'cmList',
    options: userList,
    props: { placeholder: '请选择CM', clearable: true, multiple: true, 'collapse-tags': true },
    seleProps: { label: 'label', valueName: 'alias', }
  },
  {
    type: 'SELECT',
    label: 'AM',
    value: '',
    upKey: 'amList',
    options: userList,
    props: { placeholder: '请选择AM', clearable: true, multiple: true, 'collapse-tags': true },
    seleProps: { label: 'label', valueName: 'alias', }
  },
  {
    type: 'SELECT',
    label: '发票主体',
    value: '',
    upKey: 'invoiceCompany',
    options: companyInvice,
    props: {clearable: true, placeholder: '请选择发票主体', multiple: true, "collapse-tags": true, style: 'width: 325px'},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    type: 'SELECT',
    label: '回款公司',
    value: '',
    upKey: 'flowCompany',
    options: flowCompanyList,
    props: { placeholder: '请选择回款公司', clearable: true },
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    type: 'SELECT',
    label: '坏账金额',
    value: null,
    upKey: 'badDebtFlag',
    options: [
      { label: '非空', id: 'true' },
      { label: '空', id: 'false' },
    ],
    props: { placeholder: '请选择坏账金额', clearable: true },
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },

])

const searchHandle = (params: any) => {
  fetchData({
    ...params,
    statusList: params.statusList || [],
    invoiceCompany: params.invoiceCompany || [],
    startTimeRange: params.startTimeRange || {},
  })
}

const resetHanlde = (obj: any) => {
  delete MI_params.ids
  delete MI_params.companyId
  for(let key in obj){
    obj[key] = ''
  }
  searchForm.value.dataObj.currency = []
  ElMessage('已重置搜索条件')
}

let countrieList: any = ref([])

onMounted(() => {

  invoice_companiesApi().then((rep: any) => {
    companyInvice.value = rep.map((com: string) => {
      return { label: com, id: com }
    }).concat([{label: '空白', id: '空白'}])
  })

  status_listApi().then((rep) => {
    orderOption.value = rep.map(e => {
      return { label: e, id: e }
    })
  })

  countriesListApi().then((rep: any) => {
    countrieList.value = rep.map((label: string) => ({ label, id: label }))
  })

  order_categorysListApi().then((rep: any) => {
    orderCategorysOption.value = rep.map((e: any) => ({label: categorysFunc()[e.category] + '-' + e.name, categoryId: e.id}))
  })

  flow_companyApi().then((rep: string[]) => {
    flowCompanyList.value = rep.map(e => ({label: e, id: e}))    
  })
})

onActivated(() => {

  MI_params.companyId = ''
  
  
  if(Object.keys(route.query).length > 0){
    rtQuery()
  }else if(!props.readTableOnly){
    fetchData()
  }
  
})
const rtQuery = () => {
  searchForm.value.resetForm()
  
  // 收入成本跳转过来
  if(route.query.currency){
    Object.assign(searchForm.value.dataObj, {... route.query})
  }
  // route.query.currency && Object.assign(searchForm.value.dataObj, {... route.query})
  Object.assign(MI_params, {... route.query, categoryId: parseInt(route.query.categoryId as string)})

  searchForm.value.submitHandle()
}

// 计算流水本位币
const orderFg = ref<boolean>(false)
const orderConfig = ref([
  {
    type: "TIME",
    label: "开始时间",
    value: '',
    upKey: 'start',
    props: {
      'value-format': 'YYYY-MM-DD',
      type: 'date',
      clearable: true,
    },
    rule: [
      { required: true, message: '请输选择开始时间', trigger: 'change' },
    ],
  },
  {
    type: "TIME",
    label: "结束时间",
    value: '',
    upKey: 'end',
    props: {
      'value-format': 'YYYY-MM-DD',
      type: 'date',
      clearable: true,
    },
    rule: [
      { required: true, message: '请输选择结束时间', trigger: 'change' },
    ],
  },
])
const calculateOrder = () => {
  MI_modifyForm({}, orderConfig, orderFg, async (parmas: any) => {
    await compute_rateApi(parmas, { contentType: 'formData'})
    ElMessage.success('成功')
    orderFg.value = false
    // flowEle.value.fetchData(flowEle.value.MI_params)
    // InvFetch(InvParams)
    fetchData(MI_params)
  })
}

// 获取订单
let getOrderErrTips = ref<string>('')
const getOrderFg = ref<boolean>(false)
const getOrderConfig = ref([
  {
    type: 'SELECT',
    label: '类型',
    value: '',
    upKey: 'start',
    options: [
      { label: '以完工时间', id: 'false'},
      { label: '以开始时间', id: 'true' },
      { label: '以更新时间', id: 'update' },
    ],
    props: {clearable: true, placeholder: '请选择类型'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: "TIME",
    label: "时间",
    value: [],
    upKey: '_date',
    upProps: { startKey: 'startDate', endKey: 'endDate', },
    rule: [
      { required: true, message: '请输选择时间', trigger: 'change' },
    ],
    // upProps: { startKey: 'from', endKey: 'to', },
    props: {
      type: 'daterange',
      clearable: true,
    }
  },
])
const getOrder = () => {
  getOrderErrTips.value = ''
  MI_modifyForm({}, getOrderConfig, getOrderFg, async (parmas: any) => {
    // delete parmas.date;
    try {
      await sync_orderApi(parmas, { contentType: 'formData', timeout: 180000})
      ElMessage.success('成功')
      getOrderFg.value = false
      fetchData(MI_params)
    } catch (error: any) {
      if(error.message.includes("timeout")){
        getOrderErrTips.value = '请求超时'
      }
    }
  })
}

// 修改
let dateTime = ref('')
let editBtnLoad = ref<boolean>(false)
const editFg = ref<boolean>(false)
const editHandlle = () => {
  if(orderRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  editFg.value = true
}
const submitEdit = () => {
  
  if(dateTime.value === ''){
    ElMessage.warning('请选择时间')
    return  
  }
  editBtnLoad.value = true
  financial_timeEditApi({
    dateTime: dateTime.value,
    ids: orderRows.value.map((e: any) => e.id)
  }).then(() => {
    ElMessage.warning('修改成功')
    editBtnLoad.value = false
    editFg.value = false
    fetchData(MI_params)
  }).catch(() => {
    editBtnLoad.value = false
  })
  
}
// --修改发票主体--
const modifyInvFg = ref<boolean>(false)
const modifyInvConfig = ref([
  {
    type: 'SELECT',
    label: '发票主体',
    value: '',
    upKey: 'invoiceCompany',
    options: companyInvice,
    props: {clearable: true, placeholder: '请选择发票主体',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
])
const modifyInvHandle = () => {
  if(orderRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  MI_modifyForm({} , modifyInvConfig, modifyInvFg, async (params: any) => {
    await invoice_companyApi({
      ...params,
      ids: orderRows.value.map((e: {id: string}) => e.id)
    })
    ElMessage.success('修改成功')
    fetchData(MI_params)
    modifyInvFg.value = false

  })
}

// 修改国家
const modifyCountryFg = ref<boolean>(false)
const modifyCountryConfig = ref([
  {
    type: 'SELECT',
    label: '国家',
    value: '',
    upKey: 'country',
    options: countrieList,
    props: {clearable: true, placeholder: '请选择国家',},
    seleProps: { label: 'label', valueName: 'id', },
  },
])
const modifyCountry = () => {
  if(orderRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  MI_modifyForm({} , modifyCountryConfig, modifyCountryFg, async (params: any) => {
    await modifyCountryApi({
      ...params,
      ids: orderRows.value.map((e: {id: string}) => e.id)
    })
    ElMessage.success('国家修改成功')
    fetchData(MI_params)
    modifyCountryFg.value = false
  })
}

// 导出
const expOrderHnalde = () => {
  ElMessageBox.confirm('请确认是否导出订单', '提示').then(() => {
    MI_identify.value = true
    return exportHandle(exportOrderApi, MI_params, {timeout: 0})
  }).then(() => {
    ElMessage.success('导出成功')
  }).finally(() => {
    MI_identify.value = false
  })
}

expose({
  searchForm,
  MI_params,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "订单查询" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              ref_key: "searchForm",
              ref: searchForm
            }, {
            initSearch: false,
            title: true,
            searchConfig: searchConfig.value,
          }, { onSearchFn: searchHandle }), {
              btnGroup: _withCtx(({dataObj}) => [
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  onClick: ($event: any) => (resetHanlde(dataObj))
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, void 0, "order_query"]
                ])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, !props.readTableOnly]
    ]),
    (!props.readTableOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (calculateOrder())),
            type: "primary",
            disabled: _unref(MI_identify)
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["disabled"])), [
            [_directive_permission, 'Write', "order_query"]
          ]),
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (getOrder())),
            disabled: _unref(MI_identify)
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            onClick: expOrderHnalde,
            disabled: _unref(MI_identify)
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (editHandlle())),
            class: "ml-10",
            disabled: _unref(MI_identify)
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])), [
            [_directive_permission, 'Write', "order_query"]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            onClick: modifyInvHandle,
            disabled: _unref(MI_identify)
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"])), [
            [_directive_permission, 'Write', "order_query"]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (modifyCountry())),
            disabled: _unref(MI_identify)
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled"])), [
            [_directive_permission, 'Write', "order_query"]
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: _cache[4] || (_cache[4] = (rows) => _isRef(orderRows) //@ts-ignore
 ? orderRows.value = rows : orderRows = rows),
      "max-height": _unref(MI_height) - 80 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "订单编号",
          prop: "no",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "发票编号",
          prop: "invoiceNo",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "客户ID",
          prop: "customerUsername",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "客户名称",
          prop: "customer",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "收付方名称",
          prop: "costTo",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "账户简称",
          prop: "accountName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "境内外",
          prop: "domestic",
          "show-overflow-tooltip": "",
          formatter: (row) => row.domestic === true ? '境内' : '境外'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "发票主体",
          prop: "invoiceCompany",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "回款公司",
          prop: "flowCompany",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "订单名称",
          prop: "name",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "po号",
          prop: "poNumber",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency",
          width: "65"
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber),
          "show-overflow-tooltip": "",
          width: "125"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "本位币",
          prop: "standardMoney",
          width: "100",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "USD金额",
          prop: "baseCurrencyMoney",
          align: "right"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(parseFloat(row.baseCurrencyMoney))), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "税费",
          prop: "taxRate",
          align: "right",
          "show-overflow-tooltip": "",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "客户经理",
          prop: "owner",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "开始时间",
          prop: "startTime",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "完工时间",
          prop: "deliverTime",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "确认完工时间",
          prop: "confirmDeliverTime",
          formatter: _unref(formatTime),
          width: "120",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "发票申请时间",
          prop: "invoiceDate",
          formatter: _unref(formatTime),
          width: "120",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "关单时间",
          prop: "closeTime",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "确认关单时间",
          prop: "confirmCloseTime",
          formatter: _unref(formatTime),
          width: "120",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "回款时间",
          prop: "financialTime",
          formatter: _unref(formatTime),
          width: "120",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "核销时间",
          prop: "verifyTime",
          formatter: _unref(formatTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "财务费用",
          prop: "financialExpenses",
          align: "right",
          formatter: _unref(formatNumber),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "105",
          label: "坏账",
          prop: "badDebt",
          align: "right",
          formatter: _unref(formatNumber),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [10, 30, 50 , 500, 1000],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "计算订单本位币",
      modelValue: orderFg.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((orderFg).value = $event))
    }, {
      default: _withCtx(() => [
        (orderFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: orderConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "获取订单",
      modelValue: getOrderFg.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((getOrderFg).value = $event))
    }, {
      default: _withCtx(() => [
        (_unref(getOrderErrTips).length > 0)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              closable: false,
              title: _unref(getOrderErrTips),
              type: "warning",
              effect: "dark"
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        (getOrderFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 1 }, {
          searchConfig: getOrderConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editFg).value = $event)),
      title: "修改确认关单时间"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (submitEdit())),
          loading: _unref(editBtnLoad)
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_date_picker, {
          modelValue: _unref(dateTime),
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(dateTime) ? (dateTime).value = $event : dateTime = $event)),
          type: "datetime",
          "value-format": "YYYY-MM-DDTHH:mm:ss",
          placeholder: "请选择时间",
          "default-time": new Date(2000, 1, 1, 12, 0, 0)
        }, null, 8, ["modelValue", "default-time"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改发票主体",
      modelValue: modifyInvFg.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((modifyInvFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyInvFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: modifyInvConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改国家",
      modelValue: modifyCountryFg.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((modifyCountryFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyCountryFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: modifyCountryConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})